import { useDownloadFile } from '../singleton';

export function useDownload() {
  return useDownloadFile((s) => ({
    downloadContent: s.downloadContent,
    preDownloadContent: s.preDownloadContent,
    resetFor: s.resetFor,
    loadingMap: s.loadingMap,
    progressMap: s.progressMap,
  }));
}
